import React from 'react'

export default function SiteGrid({className='', children}) {
  return (
    <div className={`site-grid ${className ? className : ''}`}>
      {children}
    </div>
  )
}
